<script setup lang="ts">
import EntryDetailsPanelClose from '@/components/entry/EntryDetailsPanelClose.vue'
import { useAttrs } from 'vue'

const emit = defineEmits<{
  /** Emitted when the preview is closed */
  close: []
}>()

defineOptions({
  name: 'TableWithPreview',
  inheritAttrs: false
})

const { class: classes, ...attrs } = useAttrs()
</script>

<template>
  <div class="flex flex-row" :class="classes">
    <div class="flex-1">
      <slot name="table" v-bind="attrs" />
    </div>

    <div v-if="$slots.preview" class="preview-wrapper flex-1">
      <div class="relative block h-full">
        <div class="preview-card">
          <div
            class="relative block min-h-full divide-y-1 divide-solid divide-secondary-300 px-4 pb-6"
          >
            <EntryDetailsPanelClose @close="emit('close')">
              <slot name="close" />
            </EntryDetailsPanelClose>
            <slot name="preview" v-bind="attrs" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@reference '../../styles/main.css';

.preview-wrapper {
  @apply fixed max-w-full w-full left-0 top-16 z-10;
  @apply lg:relative lg:ml-4 lg:top-0 lg:h-auto;
  height: calc(100% - 4rem);
}

.preview-card {
  @apply bg-white overflow-y-scroll overscroll-contain h-full;
  @apply lg:overscroll-auto lg:overflow-y-auto lg:shadow-sm lg:rounded-md lg:h-auto lg:min-h-full;
}
</style>
